// extracted by mini-css-extract-plugin
export default {"container":"new_container__Ia5i8","text":"new_text__mUS+H","para":"new_para__POpGF","btn":"new_btn__K0Z9q","msg":"new_msg__9Q8+D"};